import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Row, Col } from 'antd';
import Button from 'components/Button/index';
import Comentarios from 'components/Comentario';
import TableSelect from 'components/TableSelect';
import { montarNovaJustificativa } from 'utils/funcaoPadrao';
import { convertDatePtBrHs } from 'utils/dateFormatter';
import { fetchDownloadTodosArquivos, fetchDownloadArquivo } from 'store/fetchActions/fetchArquivo';
import { fetchNotificationApp, fetchStatusLoadingGrid, fetchNotificationDebug } from 'store/fetchActions/fetchApp';
import { ALERTA } from 'utils/consts';
import * as STable from 'components/TableSelect/styles';
import * as S from './styles';

export default function FormDetalheArquivoJustificativa({ dados }) {
  const dispatch = useDispatch();

  async function clickLinhaGrid(rowCompleta) {
    try {
      dispatch(fetchStatusLoadingGrid(true));
      const dadosArquivo = dados.arquivos.find(file => file.id === rowCompleta.key);
      fetchDownloadArquivo(dadosArquivo?.id);
      fetchNotificationApp(
        'Baixando arquivo...',
        'Aguarde finalizar o download para continuar',
        ALERTA.INFO,
        'bottomRight'
      );
      setTimeout(function () {
        dispatch(fetchStatusLoadingGrid(false));
      }, 10000);
    } catch (error) {
      fetchNotificationDebug('Erro ao abrir arquivo', error);
    }
  }

  const columns = [
    {
      title: 'Nome do Arquivo',
      dataIndex: 'nomeArquivo',
      render: (nomeArquivo, rowCompleta) => (
        <STable.OpenLife onClick={() => clickLinhaGrid(rowCompleta)}>{nomeArquivo}</STable.OpenLife>
      ),
    },
    {
      title: 'Tamanho do Arquivo',
      dataIndex: 'tamanhoArquivo',
      render: text => <p>{text} MB</p>,
    },
    {
      title: 'Data',
      dataIndex: 'data',
    },
    {
      title: 'Atribuição',
      dataIndex: 'atribuicao',
    },
  ];

  const getItemGrid = allFiles => {
    return allFiles.map(arquivo => {
      return {
        key: arquivo?.id,
        nomeArquivo: arquivo?.nomeArquivo,
        tamanhoArquivo: arquivo?.tamanho,
        data: convertDatePtBrHs(arquivo?.dtCadastro),
        atribuicao: arquivo?.atribuicao,
      };
    });
  };

  const montarArrayJustificativa = () => {
    const array = montarNovaJustificativa(dados?.formularioJustificativa);
    return (
      <Col>
        <Comentarios arrayComentario={array} />
      </Col>
    );
  };

  return (
    <>
      <Row>
        <S.ContainerLabelValor width={'100%'}>
          <S.Label>Justificativa</S.Label>
          <S.ContainerComentario>{montarArrayJustificativa() || '-'} </S.ContainerComentario>
        </S.ContainerLabelValor>
      </Row>
      <TableSelect columns={columns} data={getItemGrid(dados?.arquivos)} disabled={true} />
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          text="Baixar todos os arquivos"
          clickAction={() => fetchDownloadTodosArquivos(dados?.id)}
          disabled={dados?.arquivos?.length === 0}
        />
      </div>
    </>
  );
}

FormDetalheArquivoJustificativa.propTypes = {
  dados: PropTypes.object,
};
